import { render, staticRenderFns } from "./text_component.vue?vue&type=template&id=0ce9e2a1"
import script from "./text_component.vue?vue&type=script&lang=js"
export * from "./text_component.vue?vue&type=script&lang=js"
import style0 from "./text_component.vue?vue&type=style&index=0&id=0ce9e2a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports